import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: 'AIzaSyBC9JgQxIrlgcfepWK8-4qNgikGEmnIBIE',
    authDomain: 'monochrome-de23e.firebaseapp.com',
    projectId: 'monochrome-de23e',
    storageBucket: 'monochrome-de23e.firebasestorage.app',
    messagingSenderId: '629999692623',
    appId: '1:629999692623:web:da4f63462a61516e0b333a',
    measurementId: 'G-T2LQDPKCF5',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };
